<template>
    <component :is="component" :tabIndex="tabIndex" :post="post" :posts="posts"/>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import base from '~/components/base.vue';
// eslint-disable-next-line import/no-unresolved
import desktop from '~/components/desktop/post.vue';

export default {
    extends: base,
    components: {
        desktop
    },
    data() {
        return {
            tabIndex: this.$getRoute(this.$route).path,
            post: {},
            posts: []
        };
    },
    async asyncData({
        app: { $postApi },
        params: { pathMatch },
        redirect,
        route
    }) {
        if (route.path === '/khuyen-mai/') {
            const arrString = route.fullPath.split('/khuyen-mai/');
            redirect(`khuyen-mai${arrString[1]}`);
        }
        if (pathMatch === 'khuyen-mai') {
            const resp = await Promise.all([
                $postApi.getBySlug('thuong-nap-lan-1'),
                $postApi.getBySlug('thuong-nap-lan-2'),
                $postApi.getBySlug('hoan-tra-khong-gioi-han'),
                $postApi.getById(9202)
            ]);
            return {
                posts: [
                    resp[0].post,
                    resp[1].post,
                    resp[2].post,
                    resp[3].data
                ]
            };
        }
        if (pathMatch === 'huong-dan') {
            const resp = await Promise.all([
                $postApi.getBySlug('huong-dan-dang-ky'),
                $postApi.getBySlug('huong-dan-ca-cuoc'),
                $postApi.getBySlug('huong-dan-nap-tien'),
                $postApi.getBySlug('huong-dan-rut-tien')
            ]);
            return {
                posts: [
                    resp[0].post,
                    resp[1].post,
                    resp[2].post,
                    resp[3].post
                ]
            };
        }
        const resp = await $postApi.getBySlug(pathMatch);
        if (resp.status === 'OK') {
            return { post: resp.post || {} };
        }
        redirect('/404');
    },
    head() {
        return {
            title: this.setSeo('title'),
            meta: [
                // hid is used as unique identifier. Do not use `vmid` for it as it will not work
                { hid: 'description', name: 'description', content: this.post.meta_description }
            ]
        };
    },
    methods: {
        setSeo(tag) {
            if (this.$getRoute(this.$route).path === '/khuyen-mai' || this.$getRoute(this.$route).path === '/huong-dan') {
                const path = this.convertUrl(this.$getRoute(this.$route).fullPath);
                return this.$t(`meta.${path}.${tag}`);
            }
            return this.post.title;
        },
        convertUrl(fullPath) {
            switch (fullPath) {
                case '/khuyen-mai':
                    return 'khuyen-mai';
                case '/khuyen-mai?type=welcome':
                    return 'khuyen-mai-welcome';
                case '/khuyen-mai?type=promotion':
                    return 'khuyen-mai-promotion';
                case '/khuyen-mai?type=commission':
                    return 'khuyen-mai-commission';
                case '/huong-dan':
                    return 'huong-dan';
                default:
                    return 'index';
            }
        }
    }
};
</script>
